// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"aee398e869f3afa1bd65","303":"04b38281f337097a06b4","495":"dc02b20ab0f1e897698f"}[chunkId] + ".js";
};